
import {postCreateKeys} from '../api/postCreateKeys';

const setPostCreateKeys = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateKeys(params);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateKeys
}